// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WMns","right":"styles_right__SIDk4"};